import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, CallUpdateAccount } from "@insite/client-framework/Store/Pages/UserSetup/Handlers/SaveUser";
import { updateAccountWithResult } from "@insite/client-framework/Services/AccountService";

replaceInChain(chain, CallUpdateAccount, async props => { 
    if (!props.apiParameter.account.properties) {
        props.apiParameter.account.properties = {};
    }

    const salesRepAccessCheckbox = document.querySelector('div[data-id="salesRepAccess"] span') as HTMLInputElement;
    let salesRepChecked = salesRepAccessCheckbox.getAttribute('aria-checked') === 'true';
    if (salesRepAccessCheckbox?.checked) {
        salesRepChecked = true;
    }

    const quickQuoteAccessCheckbox = document.querySelector('div[data-id="quickQuoteAccess"] span') as HTMLInputElement;
    let quickQuoteChecked = quickQuoteAccessCheckbox.getAttribute('aria-checked') === 'true';
    if (quickQuoteAccessCheckbox?.checked) {
        quickQuoteChecked = true;
    }
    
    const updatedProperties = {
        ...props.apiParameter.account.properties,
        salesRepAccess: salesRepChecked.toString(),
        quickQuotesAccess: quickQuoteChecked.toString()
    };

    props.apiParameter.account.properties = updatedProperties;
    props.apiResult = await updateAccountWithResult(props.apiParameter);
});